import { JobDetailsStore } from './job-details.store';
import { inject, Injectable } from '@angular/core';
import { EventBusService, EventPayload } from 'src/app/shared/services/event-bus.service';
import { LocumsMarginCalculatorEvents } from '../enums/locums-margin-calculator-events.enum';

@Injectable({ providedIn: 'root' })
export class JobDetailsReducer {
    readonly jobDetailsStore = inject(JobDetailsStore);
    private readonly eventBus = inject(EventBusService);

    constructor() {
        this.listenToLoadMarginDetailsEvent();
    }

    private listenToLoadMarginDetailsEvent() {
        this.eventBus
            .on(LocumsMarginCalculatorEvents.LOCUMS_1099_MARGIN_CALCULATOR_LOAD_MARGIN_DETAILS)
            .subscribe((event: EventPayload) => {
                this.jobDetailsStore.updateJobDetailsFromData(event.payload.marginDetails.jobDetails);
            });
    }
}
